// @ts-expect-error - Automatic, Please fix when editing this file
import selectConversationInfo from '@ahmdigital/livechat/lib/selectors/select-conversation-info';

// @ts-expect-error - Automatic, Please fix when editing this file
const selectLivechatConversationInfo = (state) => selectConversationInfo(state.livechat) || {};

export default selectLivechatConversationInfo;
